export const RouteAccess = Object.freeze({
    AdministratorOnly: "administrator-only",
});

export function administratorOnlyRoute(route) {
    return {
        ...route,
        access: RouteAccess.AdministratorOnly,
    };
}

export function markRoutesAdministratorOnly(routes) {
    return routes.map(administratorOnlyRoute);
}

export function isAdministratorOnlyRoute(route) {
    return route?.access === RouteAccess.AdministratorOnly;
}
